import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService, nonFalsyPayload } from "../../core";
import { PagesWidgetCompletePostDto, PagesWidgetQrCodeDataDto } from "../../dto";

@Injectable({
  providedIn: "root"
})
export class PagesWidgetService {
  private serviceUrl = "pages/widget";

  constructor(private api: ApiService) {}

  send(payload: PagesWidgetCompletePostDto): Observable<void> {
    return this.api.post(`${this.serviceUrl}/send`, payload);
  }

  getQrCode(widgetType: string, locationId: number, widgetId?: number, cashRegisterId?: number): Observable<PagesWidgetQrCodeDataDto> {
    const params = nonFalsyPayload({ widgetType, locationId, widgetId, cashRegisterId });
    return this.api.get(`${this.serviceUrl}/${widgetType}/qr-code`, params);
  }
}
